import { useQuery } from '@tanstack/react-query';
import { getChangesQueryOptions } from '@/features/dashboard/bookingChanges/hooks/useGetChanges.ts';
import { packageNumberOf } from '@/features/dashboard/bookingChanges/types/BookingChangeHistoryDto.mapper.ts';

/**
 * Numer paczki — jej pozycja na liście paczek rezerwacji, bo kontrakt numeru
 * nie niesie.
 *
 * Zapytanie jest tym samym, którym panel boczny pobiera historię, więc React
 * Query oddaje je z cache'u; brakuje wyłącznie `select`, bo numer musi wynikać
 * z kompletu paczek, a `useGetChangeHistory` odsiewa szkice.
 */
const useChangePackageNumber = (
  bookingId: string | undefined,
  changeId: string | undefined,
) => {
  const changesQuery = useQuery(getChangesQueryOptions(bookingId));

  return {
    packageNumber: packageNumberOf(changesQuery.data ?? [], changeId),
    isLoading: changesQuery.isLoading,
  };
};

export default useChangePackageNumber;
